import { get } from './apiCall';
const getAllLocations = async function() {
        const allLocationsResponse = await get('/locations');
        return allLocationsResponse.data.locations;
}
export default getAllLocations;